export default "__VITE_ASSET__DH9TVWzk__"